import { useMedication } from '@hook'
import { yupResolver } from '@hookform/resolvers/yup'
import { FormButton, Modal, TextAreaField } from '@ui'
import { getError, showToast } from '@util'
import { FormProvider, useForm } from 'react-hook-form'
import { InferType, object, string } from 'yup'

type Props = {
  onClose: () => void
  id?: string
}

const schema = object({
  note: string().required('Please provide your reasons')
})

export const QueryMed = ({ onClose, id = '' }: Props) => {
  const methods = useForm({ resolver: yupResolver(schema) })
  const { handleSubmit, formState } = methods
  const { updateMedicationStatus } = useMedication()

  const onSubmit = async ({ note }: InferType<typeof schema>) => {
    try {
      await updateMedicationStatus({ id, payload: { status: 'review_requested', ...(note && { note }) } })
      showToast('Status updated successfully')
      onClose()
    } catch (error) {
      getError(error)
    }
  }
  return (
    <FormProvider {...methods}>
      <Modal onClose={onClose} title="Query Medication">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="p-6">
            <TextAreaField label="Reason for Query" name="note" />
          </div>
          <FormButton isLoading={formState.isSubmitting} onClose={onClose} submit="Request Review" />
        </form>
      </Modal>
    </FormProvider>
  )
}
